import { Box, Checkbox, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Selector from 'modules/core/components/Selector'
import i18n from 'modules/core/lib/i18n'

import type BulkEditForm from 'modules/employees/pages/EditInBulk/forms/BulkEdit'
import teams from 'modules/teams/store/collections/teams'

interface Props {
  bulkEditForm: BulkEditForm
  isChecked: boolean
  onChange: () => void
  onClick: () => void
  width: number
}

const TeamCell = ({ bulkEditForm, isChecked, onChange, onClick, width }: Props) => {
  const teamsIds: number[] = bulkEditForm.get('teams_ids').value
  const handleChangeTeams = (ids: unknown) => {
    bulkEditForm.setValues({
      teams_ids: ids,
    })
    onChange()
  }

  const teamOptions = teams.models.map((team) => {
    return (
      <Selector.Option
        key={team.id}
        value={team.id}
        label={team.attributes.name}
        searchValue={team.attributes.name}
        isChecked={isChecked}
      >
        <Box width="full" overflowY="hidden">
          <Text.Normal size="200" weight="medium" ellipsis>
            {team.attributes.name}
          </Text.Normal>
        </Box>
      </Selector.Option>
    )
  })

  const remainingWidth = width - 78

  return (
    <Box
      background="grey000White"
      flexDirection="row"
      justifyContent="spaceBetween"
      alignItems="center"
      height="full"
      paddingX="s16"
      paddingY="s12"
      border={{
        all: {
          width: 's2',
          style: 'solid',
          color: 'grey000White',
        },
      }}
      gap="s16"
      style={{ width: `${width}px` }}
    >
      <Box flexDirection="row" alignItems="center" gap="s16" width="full">
        <Box flexNoShrink>
          <Checkbox checked={isChecked} onChange={onClick} />
        </Box>
        <Box style={{ width: `${remainingWidth}px` }}>
          <Selector.Popover
            blankLabel={i18n.t('common.empty')}
            allSelectedLabel={i18n.t('common.all')}
            placeholder={i18n.t('common.select')}
            searchPlaceholder={i18n.t('common.search')}
            value={teamsIds || []}
            onChange={handleChangeTeams}
            onToggle={(isOpen) => !isOpen}
            isMultiSelect
          >
            {teamOptions}
          </Selector.Popover>
        </Box>
      </Box>
    </Box>
  )
}

export default observer(TeamCell)
